import React from 'react';
import { BlockContainer } from './Block.styles';
import { BlockProps } from './Block.models';

const Block: React.FC<BlockProps> = (props) => <BlockContainer {...props}>{props.children}</BlockContainer>;

export default Block;
